module.exports = __webpack_public_path__ + "static/media/defaultLogo.756256bb.svg";